__turbopack_context__.v({
  "buttonContainer": "ShareButton-module-scss-module__H4FZyG__buttonContainer",
  "buttonIcon": "ShareButton-module-scss-module__H4FZyG__buttonIcon",
  "shareButton": "ShareButton-module-scss-module__H4FZyG__shareButton",
  "sharePopover": "ShareButton-module-scss-module__H4FZyG__sharePopover",
  "smIcon": "ShareButton-module-scss-module__H4FZyG__smIcon",
});
